import React from "react";
import { Col, Row, Space, Typography } from "antd";
import { useAppSelector } from "redux/hooks";
import { infoDetailsProps } from "types/models/infoDetailsProps";
import {
  conditionFrame,
  durationType,
  durationValue,
  frameMaterial,
  lensCondition,
  lensMaterial,
  lensTypeName,
} from "../../SpectaclesCondition/config";

const SpectaclesConditionPrint = ({ data }) => {
  const value = [
    {
      key: 1,
      dboc: data?.dboc,
      durationValue: data?.durationValue,
      durationType: data?.durationType,
      conditionFrame: data?.conditionFrame,
      lensCondition: data?.lensCondition,
      lensTypeName: data?.lensTypeName,
      frameMaterial: data?.frameMaterial,
      lensMaterial: data?.lensMaterial,
    },
  ];
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Row gutter={[16, 8]}>
        {value.map((item) => {
          const _durationValue = durationValue.find((e) => {
            if (e.value === item.durationValue) {
              return e.label;
            }
          });
          const _durationType = durationType.find((e) => {
            if (e.value === item.durationType) {
              return e.label;
            }
          });
          const _conditionFrame = conditionFrame.find((e) => {
            if (e.value === item.conditionFrame) {
              return e.label;
            }
          });
          const _lensCondition = lensCondition.find((e) => {
            if (e.value === item.lensCondition) {
              return e.label;
            }
          });
          const _lensTypeName = lensTypeName.find((e) => {
            if (e.value === item.lensTypeName) {
              return e.label;
            }
          });
          const _frameMaterial = frameMaterial.find((e) => {
            if (e.value === item.lensTypeName) {
              return e.label;
            }
          });
          const _lensMaterial = lensMaterial.find((e) => {
            if (e.value === item.lensTypeName) {
              return e.label;
            }
          });
          const hasValue = Object.values(item).some(
            (value) => value !== undefined
          );
          return (
            <Space
              direction="vertical"
              style={{ width: "100%", paddingLeft: "8px" }}
              className="spectacles"
            >
              {hasValue && (
                <Typography.Text style={{ fontWeight: "bold" }}>
                  Tình trạng kính:
                </Typography.Text>
              )}
              <Row>
                {item?.durationValue && (
                  <Col span={8}>
                    <Row>
                      <Typography
                        className="title-print"
                        style={{ paddingRight: "8px" }}
                      >
                        Thời gian sử dụng:
                      </Typography>
                      <Typography.Text ellipsis={true}>
                        {_durationValue?.label} -
                      </Typography.Text>
                      <Typography.Text ellipsis={true} style={{paddingLeft:'3px'}}>
                        {" "}
                        {_durationType?.label}
                      </Typography.Text>
                    </Row>
                  </Col>
                )}
                {item?.conditionFrame && (
                  <Col span={8}>
                    <Row>
                      <Typography
                        className="title-print"
                        style={{ paddingRight: "8px" }}
                      >
                        Tình trạng gọng kính:
                      </Typography>
                      <Typography.Text ellipsis={true}>
                        {_conditionFrame?.label}
                      </Typography.Text>
                    </Row>
                  </Col>
                )}
                {item?.lensTypeName && (
                  <Col span={8}>
                    <Row>
                      <Typography
                        className="title-print"
                        style={{ paddingRight: "8px" }}
                      >
                        Loại mắt kính:
                      </Typography>
                      <Typography.Text ellipsis={true}>
                        {_lensTypeName?.label}
                      </Typography.Text>
                    </Row>
                  </Col>
                )}
                {item?.dboc && (
                  <Col span={8}>
                    <Row>
                      <Typography
                        className="title-print"
                        style={{ paddingRight: "8px" }}
                      >
                        Khoảng cách đồng tử:
                      </Typography>
                      <Typography.Text ellipsis={true}>
                        {item?.dboc}
                      </Typography.Text>
                    </Row>
                  </Col>
                )}
                {item?.conditionFrame && (
                  <Col span={8}>
                    <Row>
                      <Typography
                        className="title-print"
                        style={{ paddingRight: "8px" }}
                      >
                        Tình trạng mắt kính:
                      </Typography>
                      <Typography.Text ellipsis={true}>
                        {_conditionFrame?.label}
                      </Typography.Text>
                    </Row>
                  </Col>
                )}
                {item?.frameMaterial && (
                  <Col span={8}>
                    <Row>
                      <Typography
                        className="title-print"
                        style={{ paddingRight: "8px" }}
                      >
                        Chất liệu gọng kính:
                      </Typography>
                      <Typography.Text ellipsis={true}>
                        {_frameMaterial?.label}
                      </Typography.Text>
                    </Row>
                  </Col>
                )}
                {item?.lensMaterial && (
                  <Col span={8}>
                    <Row>
                      <Typography
                        className="title-print"
                        style={{ paddingRight: "8px" }}
                      >
                        Chất liệu mắt kính:
                      </Typography>
                      <Typography.Text ellipsis={true}>
                        {_lensMaterial?.label}
                      </Typography.Text>
                    </Row>
                  </Col>
                )}
              </Row>
            </Space>
          );
        })}
      </Row>
    </Space>
  );
};

export default SpectaclesConditionPrint;
